// DatabricksService removed for security - use TelemetryService backend proxy instead
import TelemetryService from '../services/telemetryService';

// Ball-bearing factory components: 3 lines × 3 machines × 3 components = 27
const FACTORY_COMPONENTS = [
  // Outer Ring Line — Machines 1-3
  { id: 'C-101', machine: 'M-001', line: 'Outer Ring', label: 'Spindle 101' },
  { id: 'C-102', machine: 'M-001', line: 'Outer Ring', label: 'Motor 102' },
  { id: 'C-103', machine: 'M-001', line: 'Outer Ring', label: 'Bearing 103' },
  { id: 'C-111', machine: 'M-002', line: 'Outer Ring', label: 'Wheel 111' },
  { id: 'C-112', machine: 'M-002', line: 'Outer Ring', label: 'Drive 112' },
  { id: 'C-113', machine: 'M-002', line: 'Outer Ring', label: 'Sensor 113' },
  { id: 'C-121', machine: 'M-003', line: 'Outer Ring', label: 'Cam 121' },
  { id: 'C-122', machine: 'M-003', line: 'Outer Ring', label: 'Frame 122' },
  { id: 'C-123', machine: 'M-003', line: 'Outer Ring', label: 'Lens 123' },
  // Inner Ring Line — Machines 4-6
  { id: 'C-131', machine: 'M-004', line: 'Inner Ring', label: 'Spindle 131' },
  { id: 'C-132', machine: 'M-004', line: 'Inner Ring', label: 'Motor 132' },
  { id: 'C-133', machine: 'M-004', line: 'Inner Ring', label: 'Bearing 133' },
  { id: 'C-141', machine: 'M-005', line: 'Inner Ring', label: 'Wheel 141' },
  { id: 'C-142', machine: 'M-005', line: 'Inner Ring', label: 'Drive 142' },
  { id: 'C-143', machine: 'M-005', line: 'Inner Ring', label: 'Sensor 143' },
  { id: 'C-151', machine: 'M-006', line: 'Inner Ring', label: 'Cam 151' },
  { id: 'C-152', machine: 'M-006', line: 'Inner Ring', label: 'Frame 152' },
  { id: 'C-153', machine: 'M-006', line: 'Inner Ring', label: 'Lens 153' },
  // Ball Element Line — Machines 7-9
  { id: 'C-161', machine: 'M-007', line: 'Ball Element', label: 'Die 161' },
  { id: 'C-162', machine: 'M-007', line: 'Ball Element', label: 'Plunger 162' },
  { id: 'C-163', machine: 'M-007', line: 'Ball Element', label: 'Feed 163' },
  { id: 'C-171', machine: 'M-008', line: 'Ball Element', label: 'Wheel 171' },
  { id: 'C-172', machine: 'M-008', line: 'Ball Element', label: 'Coolant 172' },
  { id: 'C-173', machine: 'M-008', line: 'Ball Element', label: 'Sensor 173' },
  { id: 'C-181', machine: 'M-009', line: 'Ball Element', label: 'Camera 181' },
  { id: 'C-182', machine: 'M-009', line: 'Ball Element', label: 'Arm 182' },
  { id: 'C-183', machine: 'M-009', line: 'Ball Element', label: 'Controller 183' },
];

// Per-component baseline profiles — realistic steady-state operating points
// sensorA = Temperature °C  (normal 65-88, warn 90, crit 100)
// sensorB = Pressure PSI    (normal 42-58, warn 60, crit 70)
// sensorC = Vibration Hz    (normal 88-115, warn 120, crit 140)
// sensorD = Speed RPM       (normal 52-72, warn 75, crit 85)
const COMPONENT_PROFILES = {
  'C-101': { A: 78, B: 52, C: 98,  D: 64 },  // Spindle — warm, moderate vib
  'C-102': { A: 84, B: 48, C: 105, D: 68 },  // Motor — higher temp+vib
  'C-103': { A: 72, B: 45, C: 92,  D: 61 },  // Bearing — cooler
  'C-111': { A: 91, B: 62, C: 118, D: 71 },  // Wheel — WARNING temp+pressure
  'C-112': { A: 86, B: 55, C: 109, D: 66 },  // Drive
  'C-113': { A: 69, B: 58, C: 94,  D: 59 },  // Sensor
  'C-121': { A: 75, B: 50, C: 101, D: 63 },  // Cam
  'C-122': { A: 88, B: 53, C: 112, D: 70 },  // Frame — near warn
  'C-123': { A: 67, B: 44, C: 88,  D: 56 },  // Lens — healthy
  'C-131': { A: 103, B: 67, C: 138, D: 82 }, // Spindle — CRITICAL all sensors
  'C-132': { A: 95,  B: 61, C: 124, D: 76 }, // Motor — WARNING
  'C-133': { A: 89,  B: 59, C: 117, D: 73 }, // Bearing — near warn
  'C-141': { A: 76, B: 49, C: 96,  D: 62 },  // Wheel
  'C-142': { A: 82, B: 54, C: 107, D: 67 },  // Drive
  'C-143': { A: 71, B: 46, C: 91,  D: 60 },  // Sensor
  'C-151': { A: 93, B: 64, C: 127, D: 78 },  // Cam — WARNING
  'C-152': { A: 80, B: 51, C: 103, D: 65 },  // Frame
  'C-153': { A: 68, B: 43, C: 89,  D: 57 },  // Lens
  'C-161': { A: 85, B: 56, C: 111, D: 69 },  // Die
  'C-162': { A: 79, B: 50, C: 99,  D: 63 },  // Plunger
  'C-163': { A: 73, B: 47, C: 93,  D: 60 },  // Feed
  'C-171': { A: 97, B: 66, C: 133, D: 80 },  // Wheel — WARNING/near-crit
  'C-172': { A: 74, B: 48, C: 95,  D: 61 },  // Coolant — healthy
  'C-173': { A: 70, B: 45, C: 90,  D: 58 },  // Sensor
  'C-181': { A: 81, B: 52, C: 104, D: 66 },  // Camera
  'C-182': { A: 77, B: 50, C: 97,  D: 63 },  // Arm
  'C-183': { A: 66, B: 42, C: 87,  D: 55 },  // Controller
};

// Add small jitter around a baseline value
const jitter = (base, spread = 3) =>
  +(base + (Math.random() - 0.5) * spread * 2).toFixed(1);

export class TelemetryFetcher {
  constructor() {
    this.telemetryService = new TelemetryService();
    this.mockData = this._buildMockSnapshot();
    this.useBackend = true;
  }

  /** One reading per component at "now", with realistic values */
  _buildMockSnapshot() {
    const now = new Date();
    return FACTORY_COMPONENTS.map(comp => {
      const p = COMPONENT_PROFILES[comp.id] || { A: 75, B: 50, C: 100, D: 65 };
      return {
        componentID:    comp.id,
        machineID:      comp.machine,
        productionLine: comp.line,
        label:          comp.label,
        sensorAReading: jitter(p.A, 2.5),   // Temperature °C
        sensorBReading: jitter(p.B, 2),     // Pressure PSI
        sensorCReading: jitter(p.C, 4),     // Vibration Hz
        sensorDReading: jitter(p.D, 2),     // Speed RPM
        timestamp: now.toISOString(),
      };
    });
  }

  /** Historical series for a given component over N time steps */
  _buildHistorical(componentID, steps = 60) {
    const p = COMPONENT_PROFILES[componentID] || { A: 75, B: 50, C: 100, D: 65 };
    const series = [];
    // Simulate a gradual warm-up + occasional spike pattern
    for (let i = steps; i >= 0; i--) {
      const phase = (steps - i) / steps; // 0→1
      const warmup = phase * 0.08;       // slight upward drift
      const spike  = i % 12 === 0 ? (Math.random() * 6) : 0; // periodic spikes
      series.push({
        t: new Date(Date.now() - i * 60_000).toISOString(),
        A: jitter(p.A * (1 + warmup) + spike, 2),
        B: jitter(p.B * (1 + warmup * 0.5), 1.5),
        C: jitter(p.C * (1 + warmup * 0.7) + spike * 0.8, 3),
        D: jitter(p.D * (1 + warmup * 0.3), 1.5),
      });
    }
    return series;
  }

  async fetchLatestTelemetry(componentID) {
    try {
      const result = await this.telemetryService.fetchLatestTelemetry();
      if (result.success && result.data?.length > 0) {
        const found = result.data.find(d => d.componentID === componentID);
        if (found) return found;
      }
    } catch (_) {}

    return this.mockData.find(d => d.componentID === componentID) || null;
  }

  async fetchHistoricalTelemetry(componentID, startTime, endTime) {
    await this._delay();
    const hist = this._buildHistorical(componentID);
    const start = new Date(startTime);
    const end   = new Date(endTime);
    return hist
      .filter(d => {
        const t = new Date(d.t);
        return t >= start && t <= end;
      })
      .map(d => ({
        componentID,
        sensorAReading: d.A,
        sensorBReading: d.B,
        sensorCReading: d.C,
        sensorDReading: d.D,
        timestamp: d.t,
      }));
  }

  async fetchAllLatestTelemetry() {
    try {
      const result = await this.telemetryService.fetchLatestTelemetry();
      if (result.success && result.data?.length > 0) return result.data;
    } catch (_) {}

    // Refresh mock values with fresh jitter each call
    this.mockData = this._buildMockSnapshot();
    return this.mockData;
  }

  async fetchTelemetryByTimeRange(startTime, endTime) {
    await this._delay();
    const start = new Date(startTime);
    const end   = new Date(endTime);
    const all = [];
    for (const comp of FACTORY_COMPONENTS) {
      const hist = this._buildHistorical(comp.id);
      hist.forEach(d => {
        const t = new Date(d.t);
        if (t >= start && t <= end) {
          all.push({
            componentID:    comp.id,
            sensorAReading: d.A,
            sensorBReading: d.B,
            sensorCReading: d.C,
            sensorDReading: d.D,
            timestamp: d.t,
          });
        }
      });
    }
    return all.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  }

  _delay() {
    return new Promise(r => setTimeout(r, 80 + Math.random() * 120));
  }

  getSensorDefinitions() {
    return {
      sensorAReading: { label: 'Temperature', unit: '°C',  min: 0,  max: 120 },
      sensorBReading: { label: 'Pressure',    unit: 'PSI', min: 0,  max: 80  },
      sensorCReading: { label: 'Vibration',   unit: 'Hz',  min: 0,  max: 160 },
      sensorDReading: { label: 'Speed',       unit: 'RPM', min: 0,  max: 100 },
    };
  }

  getHealthThresholds() {
    return {
      sensorAReading: { warning: 90,  critical: 100 },
      sensorBReading: { warning: 60,  critical: 70  },
      sensorCReading: { warning: 120, critical: 140 },
      sensorDReading: { warning: 75,  critical: 85  },
    };
  }

  analyzeSensorHealth(value, sensorType) {
    const t = this.getHealthThresholds()[sensorType];
    if (!t) return 'unknown';
    if (value >= t.critical) return 'critical';
    if (value >= t.warning)  return 'warning';
    return 'healthy';
  }

  getComponentHealth(telemetryData) {
    if (!telemetryData) return 'unknown';
    const sensors = ['sensorAReading', 'sensorBReading', 'sensorCReading', 'sensorDReading'];
    const levels = sensors.map(s => this.analyzeSensorHealth(telemetryData[s], s));
    if (levels.includes('critical')) return 'critical';
    if (levels.includes('warning'))  return 'warning';
    return 'healthy';
  }

  /** Expose factory component list for other components to use */
  static getFactoryComponents() { return FACTORY_COMPONENTS; }
  static getComponentProfiles()  { return COMPONENT_PROFILES; }
}
